import { HTMLAttributes, useEffect, useState } from 'react';

import { LocalStorageKeys } from 'commons';
import { Menu } from 'components';
import { getLocalStorageItem, setLocalStorageItem } from 'helpers';
import { useMenu } from 'hooks';

import * as S from './styles';

interface Props extends HTMLAttributes<HTMLDivElement> {}

export function Main({ children, ...rest }: Props) {
  const { retractableBreakPoint, showMenu, setShowMenu } = useMenu();
  const [expanded, setExpanded] = useState(
    () => getLocalStorageItem(LocalStorageKeys.MenuExpanded) === true
  );

  useEffect(() => {
    setLocalStorageItem(LocalStorageKeys.MenuExpanded, expanded);
  }, [expanded]);

  function closeMenu() {
    setShowMenu(false);
    setExpanded(false);
  }

  return (
    <S.Main {...rest}>
      <S.MenuSection
        $showMenu={showMenu}
        $breakPoint={retractableBreakPoint}
        $expanded={expanded}
      >
        <Menu
          closeMenu={closeMenu}
          expanded={expanded}
          setExpanded={setExpanded}
        />
      </S.MenuSection>

      <S.PageSection $expanded={expanded}>{children}</S.PageSection>
    </S.Main>
  );
}
